import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';

const Safety = () => {
  useEffect(() => {
    
  
  }, [])
  
  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>Safety</h1>
        <h3>Cure disease - Secure generations!</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              Safety
            </div>
            <Scrollspy
              offset={-140}
              className="scrollspy" items={['Safety', 'Proper', 'COVID', 'Animal','Project']}
              currentClassName="active">
              <li><a href="#Safety">Safety measures in CityU lab</a></li>
              <li><a href="#Proper">Proper disposal</a></li>
              <li><a href="#COVID">COVID-19 precautions</a></li>
              <li><a href="#Animal">Animal Safety</a></li>
              <li><a href="#Project">Safe Project Design</a></li>
            </Scrollspy>
            
          </div>

        </div>
        <div className="main_lab_style">
          <section id="Safety">
            
          <h1>
            Safety measures in CityU lab:
          </h1>
          
          <p>Experimentation conducted in CityU Lab is equipped with safety features including: <br /><br />&bull; First Aid Kit <br />&bull; Fire Extinguisher <br />&bull; Eyewash solution<br /> <br />Besides, students are required to wear lab coats and protective gloves when doing experiments.</p>

          </section>
          <section id="Proper">
          <h1>
            Proper disposal:
          </h1>
            <p>
              Students are required to label all solutions and plates and dispose waste materials into proper bins. All pipette tips, gels, used filter papers, and other used solutions will be disposed in the bio-hazardous waste bins.</p>
            
          

          

          </section>
          <section id="COVID">
          <h1>COVID-19 precautions:</h1>
          <p>
            
              In light of the COVID-19 pandemic, students are required to keep the the social distance, follow hygiene essentials, and wear a face mask at all times when
              performing experiments in the lab.
          </p>

          </section>

          <section id="Animal">
            <p><h1>Animal Safety:</h1></p>
            <p>
              <strong>
              The animal work has NOT YET been approved by iGEM Safety & Security, and the experiments HAVE NOT BEEN performed within the scope of the iGEM project.
              </strong>
            </p>  
              <p>
              <strong>
              The protocol prepared by the iGEM team has already been approved by the Animal Research Ethics Sub-Committee at the City University of Hong Kong and the Hong Kong Government.
              </strong>
            </p>

            <p>
              The animal work will take place in the animal facility of the City University of Hong Kong (LARU). One member of the iGEM team (Ho-Jung Choe) and the PI (Dr. Maria Babak) will perform the experiments, both of them have received an animal governmental license to perform in vivo experiments with mice. Dr Babak has been working with animals for over 10 years and has approved protocols for various tumour efficacy models. Ho-Jung Choe has passed all the required training by LARU and the Hong Kong Government and has official access to the animal facility. Also, both of them have acquired Hep B and tetanus vaccinations.

            </p>
          </section>

          <section id="Project">
            <h1 style={{ marginBottom: 0 }}>SeCure iGEM</h1>
            <h1 style={{ fontFamily: '"Quicksand Bold"', marginTop: 0, paddingTop: 0 }}>Safe Project Design</h1>
            <h3 style={{ padding: '10px 40px', background:'#123051', color:'#FFF',display:'inline'}}>
              Project Description
            </h3>
            <p>
              Our fungus is engineered by altering secalonic acid genes
              and exhibits potent anticancer properties. Escherichia coli with DH5-
              alpha strain, Aspergillus Oryzae, and Aspergillus aculeatus CBS 172.66
              are used in this project.
              <b> To evaluate anticancer properties</b> , colorectal and ovarian cancer cell
              lines, healthy cell lines, and mouse cancer cell lines are planned to use upon approval.

            </p>
            <br />

            <h3 style={{ padding: '10px 40px', background: '#123051', color: '#FFF', display: 'inline' }}>
              Risk management

            </h3>
            <p>
              The Biosafety level of the lab is level 2 (moderate containment lab) which works with pathogens, and infectious organisms and poses a
              moderate health hazard.
              <b>To ensure a safe lab environment </b>, lab members are required to wear
              PPE with face shields. In addition, the use of biological safety cabinets
              (BSC) will be trained to handle hazardous biological samples.
            </p>
            <br />
            <h3 style={{ fontFamily: '"Quicksand Bold"',textAlign:'center', color:'#0D4B5E',fontSize:25, padding:'10px 50px'}}>
              To ensure safe project design,
              we have adopted the following safety measures:
            </h3>
            <br />

            <h3 style={{ padding: '10px 40px', background: '#123051', color: '#FFF', display: 'inline' }}>
              Risk management
            </h3>
            <p>
              The departmental safety officer is consulted and the
              departmental biological protection officer is approached if a
              hazard or risk is detected. Also, biosafety measures such as
              accident reporting, and wearing PPE are implemented beforehand
              to manage project risks properly and quickly.
            </p>
            <br />

            <h3 style={{ padding: '10px 40px', background: '#123051', color: '#FFF', display: 'inline' }}>
              Safety training
            </h3>
            <p>
              Required safety training is provided by the departmental safety
              officer who is responsible for reducing the risk in our project. Prior
              to doing project lab work, all team members should undergo safety
              training,
              in which content includes lab access, biosafety equipment,
              personnel biosafety, etc.
            </p>
            <br />

            <h3 style={{ padding: '10px 40px', background: '#123051', color: '#FFF', display: 'inline' }}>
              Handling hazardous chemicals
            </h3>
            <p>
              Hazardous chemicals used in the project: ethyl acetate, ethanol,
              DMSO, cremophor, MTT, formic acid, acetonitrile & methanol.
              <br />

              As they are hazardous, we implement the following safety measures:
              <ol>
                <li>
                  Hazardous chemicals are stored in a well-ventilated area
                </li>
                <li>
                  Protective gloves, safety googles and face shields are worn
                </li>
                <li>
                  Experiments are carried out in fumehood
                </li>
              </ol>
              
            </p>
            <br />


            <h3 style={{ padding: '10px 40px', background: '#123051', color: '#FFF', display: 'inline' }}>
              Safe waste management
            </h3>
            <p>
              To avoid environmental contamination, hazardous chemicals, and biological samples are disposed to the labelled waste cabinets.
              The wastes of agar gel are collected in a yellow biowaste plastic 20L
              pail in the laboratory which contains liquids released by agar gel.
              After sealing the pail and filling in the tag, the pail is placed beside
              other waste awaiting removal by EPS Environmental Protection
              Technicians.
            </p>
            <br />
          </section>
        </div>
      </section>
    </div>
  );
}

export default Safety;
